import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StringSearch} from '../../../services/common-datatypes';
import {RequiredInput} from '../../../decorators/common.decorators';

@Component({
    selector: 'app-text-search-complex',
    templateUrl: './text-search-complex.component.html',
    styleUrls: ['./text-search-complex.component.scss']
})
export class TextSearchComplexComponent {

    @Input() @RequiredInput translationPrefix!: string;

    @Input() @RequiredInput stringSearch: StringSearch | undefined;
    @Output() stringSearchChange = new EventEmitter<StringSearch>();

    constructor() {
    }

    clearSearch() {
        if (this.stringSearch) this.stringSearch.reset();
        this.dataChange();
    }

    dataChange() {
        if (this.stringSearch) this.stringSearchChange.emit(this.stringSearch);
    }
}
